// plugins/recaptcha.js
import { VueReCaptcha } from 'vue-recaptcha-v3'
// The plugin enables the usage of Google reCAPTCHA in a Nuxt.js application
// by registering the VueReCaptcha plugin with the necessary configuration options.
export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.hook('vuetify:ssr-client-hints', ({ vuetifyOptions, ssrClientHints, ssrClientHintsConfiguration }) => {
        // your logic here
        // vuetifyOptions is the Vuetify options object
        // ssrClientHints is the detected client hints
        // ssrClientHintsConfiguration is the configuration object
        ssrClientHints.reloadOnFirstRequest = true;
    })
})
